export default __webpack_public_path__ + "static/media/photography1.484fba72.jpg";